import { render } from "./CommissionRates.vue?vue&type=template&id=118bf6d8&scoped=true"
import script from "./CommissionRates.vue?vue&type=script&lang=js"
export * from "./CommissionRates.vue?vue&type=script&lang=js"

import "./CommissionRates.vue?vue&type=style&index=0&id=118bf6d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118bf6d8"]])

export default __exports__